"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TablesService", {
    enumerable: true,
    get: function() {
        return TablesService;
    }
});
const _common = require("@nestjs/common");
const _isomorphicdompurify = /*#__PURE__*/ _interop_require_default(require("isomorphic-dompurify"));
const _nocodbsdk = require("nocodb-sdk");
const _columnsservice = require("~/services/columns.service");
const _metadiffsservice = require("~/services/meta-diffs.service");
const _tableHelpers = require("~/helpers/tableHelpers");
const _columnwebhookmanager = require("~/utils/column-webhook-manager");
const _models = require("~/models");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _ProjectMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/v2/ProjectMgrv2"));
const _catchError = require("~/helpers/catchError");
const _getColumnPropsFromUIDT = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnPropsFromUIDT"));
const _getColumnUiType = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnUiType"));
const _getTableName = /*#__PURE__*/ _interop_require_wildcard(require("~/helpers/getTableName"));
const _mapDefaultDisplayValue = /*#__PURE__*/ _interop_require_default(require("~/helpers/mapDefaultDisplayValue"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _helpers = require("~/helpers");
const _globals = require("~/utils/globals");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _uniqueConstraintHelpers = require("~/helpers/uniqueConstraintHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let TablesService = class TablesService {
    async tableUpdate(context, param) {
        var _source_getConfig;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const model = await _models.Model.get(context, param.tableId);
        const base = await _models.Base.getWithInfo(context, param.table.base_id || model.base_id);
        const source = base.sources.find((b)=>b.id === model.source_id);
        if (model.base_id !== base.id) {
            _catchError.NcError.get(context).invalidRequestBody('Model does not belong to base');
        }
        // if meta/description present update and return
        // todo: allow user to update meta  and other prop in single api call
        if ('meta' in param.table || 'description' in param.table) {
            await _models.Model.updateMeta(context, param.tableId, param.table);
            this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_UPDATE, {
                table: param.table,
                prevTable: model,
                req: param.req,
                context
            });
            _NocoSocket.default.broadcastEvent(context, {
                event: _nocodbsdk.EventType.META_EVENT,
                payload: {
                    action: 'table_update',
                    payload: _extends({}, model, param.table)
                }
            }, context.socket_id);
            return true;
        }
        // allow user to only update meta json data when source is restricted changes to schema
        if (source == null ? void 0 : source.is_schema_readonly) {
            _catchError.NcError.get(context).sourceMetaReadOnly(source.alias);
        }
        if (!param.table.table_name) {
            _catchError.NcError.get(context).invalidRequestBody('Missing table name `table_name` property in request body');
        }
        if (source.type === 'databricks') {
            param.table.table_name = param.table.table_name.replace(/\s/g, '_').toLowerCase();
        }
        if (source.isMeta(true) && base.prefix && !source.isMeta(true, 1)) {
            if (!param.table.table_name.startsWith(base.prefix)) {
                param.table.table_name = `${base.prefix}_${param.table.table_name}`;
            }
        }
        param.table.table_name = _isomorphicdompurify.default.sanitize(param.table.table_name);
        // validate table name
        if (/^\s+|\s+$/.test(param.table.table_name)) {
            _catchError.NcError.get(context).invalidRequestBody('Leading or trailing whitespace not allowed in table names');
        }
        const specialCharRegex = /[./\\]/g;
        if (specialCharRegex.test(param.table.table_name)) {
            const match = param.table.table_name.match(specialCharRegex);
            _catchError.NcError.get(context).invalidRequestBody('Following characters are not allowed ' + match.map((m)=>JSON.stringify(m)).join(', '));
        }
        const replaceCharRegex = /[$?]/g;
        if (replaceCharRegex.test(param.table.table_name)) {
            param.table.table_name = param.table.table_name.replace(replaceCharRegex, '_');
        }
        if (!await _models.Model.checkTitleAvailable(context, {
            table_name: param.table.table_name,
            base_id: base.id,
            source_id: source.id
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'table',
                alias: param.table.table_name,
                base: context.base_id,
                label: 'name'
            });
        }
        if (!param.table.title) {
            param.table.title = (0, _getTableName.default)(param.table.table_name, base.prefix, source);
        }
        if (!await _models.Model.checkAliasAvailable(context, {
            title: param.table.title,
            base_id: base.id,
            source_id: source.id
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'table',
                alias: param.table.title,
                base: context.base_id
            });
        }
        const sqlMgr = await _ProjectMgrv2.default.getSqlMgr(context, base);
        const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
        let tableNameLengthLimit = 255;
        const sqlClientType = sqlClient.knex.clientType();
        if (sqlClientType === 'mysql2' || sqlClientType === 'mysql') {
            tableNameLengthLimit = 64;
        } else if (sqlClientType === 'pg') {
            tableNameLengthLimit = 63;
        }
        if (param.table.table_name.length > tableNameLengthLimit) {
            _catchError.NcError.get(context).invalidRequestBody(`Table name exceeds ${tableNameLengthLimit} characters`);
        }
        await sqlMgr.sqlOpPlus(source, 'tableRename', _extends({}, param.table, {
            tn: param.table.table_name,
            tn_old: model.table_name,
            schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
        }));
        await _models.Model.updateAliasAndTableName(context, param.tableId, param.table.title, param.table.table_name);
        const result = await _models.Model.get(context, param.tableId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_UPDATE, {
            table: param.table,
            prevTable: model,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'table_update',
                payload: result
            }
        }, context.socket_id);
        return true;
    }
    async reorderTable(context, param) {
        const model = await _models.Model.get(context, param.tableId);
        const res = await _models.Model.updateOrder(context, param.tableId, param.order);
        this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_UPDATE, {
            prevTable: model,
            table: _extends({}, model, {
                order: param.order
            }),
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'table_update',
                payload: _extends({}, model, {
                    order: param.order
                })
            }
        }, context.socket_id);
        return res;
    }
    async tableDelete(context, param) {
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const table = await _models.Model.getByIdOrName(context, {
            id: param.tableId
        });
        if ((table == null ? void 0 : table.synced) && !param.forceDeleteSyncs) {
            _catchError.NcError.get(context).invalidRequestBody('Synced tables cannot be deleted');
        }
        await table.getColumns(context);
        if (table.mm) {
            var _tables_, _relColumns_, _tables_1, _relColumns_1;
            const columns = await table.getColumns(context);
            // get table names of the relation which uses the current table as junction table
            const tables = await Promise.all(columns.filter((c)=>(0, _nocodbsdk.isLinksOrLTAR)(c)).map((c)=>c.colOptions.getRelatedTable()));
            // get relation column names
            const relColumns = await Promise.all(tables.map((t)=>{
                return t.getColumns(_extends({}, context, {
                    base_id: t.base_id,
                    workspace_id: t.fk_workspace_id
                })).then((cols)=>{
                    return cols.find((c)=>{
                        return (0, _nocodbsdk.isLinksOrLTAR)(c) && c.colOptions.type === _nocodbsdk.RelationTypes.MANY_TO_MANY && c.colOptions.fk_mm_model_id === table.id;
                    });
                });
            }));
            _catchError.NcError.get(context).invalidRequestBody(`This is a many to many table for ${(_tables_ = tables[0]) == null ? void 0 : _tables_.title} (${(_relColumns_ = relColumns[0]) == null ? void 0 : _relColumns_.title}) & ${(_tables_1 = tables[1]) == null ? void 0 : _tables_1.title} (${(_relColumns_1 = relColumns[1]) == null ? void 0 : _relColumns_1.title}). You can disable "Show M2M tables" in base settings to avoid seeing this.`);
        } else if (!param.forceDeleteRelations) {
            // if table is using in custom relation as junction table then delete all the relation
            const relations = await _Noco.default.ncMeta.metaList2(table.fk_workspace_id, table.base_id, _globals.MetaTable.COL_RELATIONS, {
                condition: {
                    fk_mm_model_id: table.id
                }
            });
            if (relations.length) {
                const relCol = await _models.Column.get(context, {
                    colId: relations[0].fk_column_id
                });
                const relTable = await _models.Model.get(context, relCol.fk_model_id);
                _catchError.NcError.tableAssociatedWithLink(table.id, {
                    customMessage: `This is a many to many table for '${relTable == null ? void 0 : relTable.title}' (${relTable == null ? void 0 : relTable.title}), please delete the column before deleting the table.`
                });
            }
        }
        const base = await _models.Base.getWithInfo(context, table.base_id);
        const source = base.sources.find((b)=>b.id === table.source_id);
        const relationColumns = table.columns.filter((c)=>(0, _nocodbsdk.isLinksOrLTAR)(c));
        const deleteRelations = source.isMeta() || param.forceDeleteRelations;
        if ((relationColumns == null ? void 0 : relationColumns.length) && !deleteRelations) {
            const referredTables = await Promise.all(relationColumns.map(async (c)=>c.getColOptions(context).then((opt)=>opt.getRelatedTable(context)).then((t)=>t == null ? void 0 : t.title)));
            _catchError.NcError.get(context).invalidRequestBody(`Table can't be deleted since Table is being referred in following tables : ${referredTables.join(', ')}. Delete LinkToAnotherRecord columns and try again.`);
        }
        // TODO: replace this with the one that's generated by table webhook manager
        // currently this one is to prevent webhook to trigger when delete table
        const columnWebhookManager = (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context).withModelId(table.id)).forDelete();
        // start a transaction
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        let result;
        try {
            // delete all relations
            for (const c of relationColumns){
                // skip if column is hasmany relation to mm table
                if (c.system && !table.mm) {
                    continue;
                }
                // verify column exist or not and based on that delete the column
                if (!await _models.Column.get(context, {
                    colId: c.id
                }, ncMeta)) {
                    continue;
                }
                await this.columnsService.columnDelete(context, {
                    req: param.req,
                    columnId: c.id,
                    user: param.user,
                    forceDeleteSystem: true,
                    columnWebhookManager
                }, ncMeta);
            }
            const sqlMgr = await _ProjectMgrv2.default.getSqlMgr(context, base, ncMeta);
            table.tn = table.table_name;
            table.columns = table.columns.filter((c)=>!(0, _nocodbsdk.isVirtualCol)(c));
            table.columns.forEach((c)=>{
                c.cn = c.column_name;
            });
            if (table.type === _nocodbsdk.ModelTypes.TABLE) {
                await sqlMgr.sqlOpPlus(source, 'tableDelete', table);
            } else if (table.type === _nocodbsdk.ModelTypes.VIEW) {
                await sqlMgr.sqlOpPlus(source, 'viewDelete', _extends({}, table, {
                    view_name: table.table_name
                }));
            }
            result = await table.delete(context, ncMeta);
            await ncMeta.commit();
        } catch (e) {
            await ncMeta.rollback();
            if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            this.logger.error('Error deleting table', e);
            _catchError.NcError.get(context).tableError('Bad Request');
        }
        if (result) {
            this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_DELETE, {
                table,
                user: param.user,
                req: param.req,
                context
            });
            _NocoSocket.default.broadcastEvent(context, {
                event: _nocodbsdk.EventType.META_EVENT,
                payload: {
                    action: 'table_delete',
                    payload: table
                }
            }, context.socket_id);
        }
        return result;
    }
    async getTableWithAccessibleViews(context, param) {
        const table = await _models.Model.getWithInfo(context, {
            id: param.tableId
        });
        if (!table) {
            _catchError.NcError.tableNotFound(param.tableId);
        }
        // Check table visibility permission
        // Base owners always have access, but we still need to check for others
        if (!(0, _nocodbsdk.isServiceUser)(param.user)) {
            const hasAccess = await (0, _tableHelpers.hasTableVisibilityAccess)(context, param.tableId, param.user);
            if (!hasAccess) {
                // Return 404 as if table doesn't exist
                _catchError.NcError.tableNotFound(param.tableId);
            }
        }
        if ((0, _nocodbsdk.isServiceUser)(param.user, _nocodbsdk.ServiceUserType.WORKFLOW_USER)) {
            await table.getViews(context);
        } else {
            // todo: optimise
            const viewList = await this.xcVisibilityMetaGet(context, table.base_id, [
                table
            ]);
            //await View.list(param.tableId)
            table.views = viewList.filter((view)=>{
                var _param_user;
                return Object.keys(((_param_user = param.user) == null ? void 0 : _param_user.roles) || {}).some((role)=>{
                    var _param_user;
                    return ((_param_user = param.user) == null ? void 0 : _param_user.roles[role]) && !view.disabled[role];
                });
            });
        }
        return table;
    }
    async xcVisibilityMetaGet(context, baseId, _models1 = null, includeM2M = true) {
        // todo: move to
        const roles = [
            'owner',
            'creator',
            'viewer',
            'editor',
            'commenter',
            'guest'
        ];
        const defaultDisabled = roles.reduce((o, r)=>_extends({}, o, {
                [r]: false
            }), {});
        let models = _models1 || await _models.Model.list(context, {
            base_id: baseId,
            source_id: undefined
        });
        models = includeM2M ? models : models.filter((t)=>!t.mm);
        const result = await models.reduce(async (_obj, model)=>{
            const obj = await _obj;
            const views = await model.getViews(context);
            for (const view of views){
                obj[view.id] = _extends({
                    ptn: model.table_name,
                    _ptn: model.title,
                    ptype: model.type,
                    tn: view.title,
                    _tn: view.title,
                    table_meta: model.meta
                }, view, {
                    disabled: _extends({}, defaultDisabled)
                });
            }
            return obj;
        }, Promise.resolve({}));
        const disabledList = await _models.ModelRoleVisibility.list(context, baseId);
        for (const d of disabledList){
            if (result[d.fk_view_id]) result[d.fk_view_id].disabled[d.role] = !!d.disabled;
        }
        return Object.values(result);
    }
    async getAccessibleTables(context, param) {
        var _param_roles;
        const viewList = await this.xcVisibilityMetaGet(context, param.baseId);
        // todo: optimise
        const tableViewMapping = viewList.reduce((o, view)=>{
            o[view.fk_model_id] = o[view.fk_model_id] || 0;
            if (Object.values(_nocodbsdk.ProjectRoles).some((role)=>param.roles[role] && !view.disabled[role])) {
                o[view.fk_model_id]++;
            }
            return o;
        }, {});
        let tableList = (await _models.Model.list(context, {
            base_id: param.baseId,
            source_id: param.allSources ? undefined : param.sourceId
        })).filter((t)=>tableViewMapping[t.id]);
        // Filter tables based on TABLE_VISIBILITY permission
        // Base owners always see all tables, so skip filtering for them
        if (!((_param_roles = param.roles) == null ? void 0 : _param_roles[_nocodbsdk.ProjectRoles.OWNER]) && !(0, _nocodbsdk.isServiceUser)(param.user)) {
            const permissions = await _models.Permission.list(context, param.baseId);
            const accessibleTableIds = new Set();
            for (const table of tableList){
                // For shared bases (public bases), show tables with default visibility (Everyone) or "Viewers & up" permission
                if (param.isPublicBase) {
                    if ((0, _tableHelpers.hasDefaultTableVisibility)(table.id, permissions) || (0, _tableHelpers.hasViewersAndUpTableVisibility)(table.id, permissions)) {
                        accessibleTableIds.add(table.id);
                    }
                } else if (param.user) {
                    var _param_user;
                    let user = (_param_user = param.user) != null ? _param_user : context.user;
                    if (!user) {
                        user = {
                            base_roles: param.roles
                        };
                    }
                    // For regular bases, check user access
                    const hasAccess = await (0, _tableHelpers.hasTableVisibilityAccess)(context, table.id, user, permissions);
                    if (hasAccess) {
                        accessibleTableIds.add(table.id);
                    }
                }
            }
            tableList = tableList.filter((t)=>accessibleTableIds.has(t.id));
        }
        return param.includeM2M ? tableList : tableList.filter((t)=>!t.mm);
    }
    async tableCreate(context, param) {
        var _param_table_table_name;
        var _tableCreatePayLoad_columns;
        // before validating add title for columns if only column name is present
        if (param.table.columns) {
            param.table.columns.forEach((c)=>{
                if (!c.title && c.column_name) {
                    c.title = c.column_name;
                }
            });
        }
        // before validating add title for table if only table name is present
        if (!param.table.title && param.table.table_name) {
            param.table.title = param.table.table_name;
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/TableReq', param.table, false, context);
        const tableCreatePayLoad = _extends({}, param.table, param.synced ? {
            synced: true
        } : {});
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const base = await _models.Base.getWithInfo(context, param.baseId);
        let source = base.sources[0];
        if (param.sourceId) {
            source = base.sources.find((b)=>b.id === param.sourceId);
        }
        if (!param.isDuplicateOperation) {
            // add CreatedTime and LastModifiedTime system columns if missing in request payload
            tableCreatePayLoad.columns = (0, _tableHelpers.repopulateCreateTableSystemColumns)(context, {
                columns: tableCreatePayLoad.columns,
                clientType: source.type
            });
        }
        //#region validating table title and table name
        if (!tableCreatePayLoad.title) {
            _catchError.NcError.get(context).invalidRequestBody('Missing table `title` property in request body');
        }
        if (!tableCreatePayLoad.table_name) {
            tableCreatePayLoad.table_name = tableCreatePayLoad.title;
        }
        if (!await _models.Model.checkAliasAvailable(context, {
            title: tableCreatePayLoad.title,
            base_id: base.id,
            source_id: source.id
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'table',
                alias: tableCreatePayLoad.title,
                base: context.base_id
            });
        }
        if (source.type === 'databricks') {
            tableCreatePayLoad.table_name = tableCreatePayLoad.table_name.replace(/\s/g, '_').toLowerCase();
        }
        if (source.is_meta && base.prefix) {
            if (!tableCreatePayLoad.table_name.startsWith(base.prefix)) {
                tableCreatePayLoad.table_name = `${base.prefix}_${tableCreatePayLoad.table_name}`;
            }
        }
        tableCreatePayLoad.table_name = _isomorphicdompurify.default.sanitize(tableCreatePayLoad.table_name);
        // validate table name
        if (/^\s+|\s+$/.test(tableCreatePayLoad.table_name)) {
            _catchError.NcError.get(context).invalidRequestBody('Leading or trailing whitespace not allowed in table names');
        }
        const specialCharRegex = /[./\\]/g;
        if (specialCharRegex.test((_param_table_table_name = param.table.table_name) != null ? _param_table_table_name : param.table.title)) {
            var _param_table_title;
            const match = ((_param_table_title = param.table.title) != null ? _param_table_title : param.table.table_name).match(specialCharRegex);
            _catchError.NcError.get(context).invalidRequestBody('Following characters are not allowed ' + match.map((m)=>JSON.stringify(m)).join(', '));
        }
        const replaceCharRegex = /[$?]/g;
        if (replaceCharRegex.test(tableCreatePayLoad.table_name)) {
            tableCreatePayLoad.table_name = tableCreatePayLoad.table_name.replace(replaceCharRegex, '_');
        }
        if (!await _models.Model.checkTitleAvailable(context, {
            table_name: tableCreatePayLoad.table_name,
            base_id: base.id,
            source_id: source.id
        })) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'table',
                alias: tableCreatePayLoad.table_name,
                base: context.base_id,
                label: 'name'
            });
        }
        if (!tableCreatePayLoad.title) {
            tableCreatePayLoad.title = (0, _getTableName.default)(tableCreatePayLoad.table_name, base.prefix, source);
        }
        const sqlMgr = await _ProjectMgrv2.default.getSqlMgr(context, base);
        const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
        let tableNameLengthLimit = 255;
        const sqlClientType = sqlClient.knex.clientType();
        if (sqlClientType === 'mysql2' || sqlClientType === 'mysql') {
            tableNameLengthLimit = 64;
        } else if (sqlClientType === 'pg') {
            tableNameLengthLimit = 63;
        }
        if (tableCreatePayLoad.table_name.length > tableNameLengthLimit) {
            _catchError.NcError.get(context).invalidRequestBody(`Table name exceeds ${tableNameLengthLimit} characters`);
        }
        //#endregion validating table title and table name
        const mxColumnLength = _models.Column.getMaxColumnNameLength(sqlClientType);
        const uniqueColumnNameCount = {};
        (0, _mapDefaultDisplayValue.default)(tableCreatePayLoad.columns);
        const virtualColumns = [];
        for (const column of tableCreatePayLoad.columns){
            if (!(0, _nocodbsdk.isVirtualCol)(column) || (0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(column) && column.system || (0, _nocodbsdk.isCreatedOrLastModifiedByCol)(column) && column.system) {
                // set column name using title if not present
                if (!column.column_name && column.title) {
                    column.column_name = column.title;
                }
                // - 5 is a buffer for suffix
                column.column_name = (0, _helpers.sanitizeColumnName)(column.column_name.slice(0, mxColumnLength - 5), source.type);
                if (uniqueColumnNameCount[column.column_name]) {
                    let suffix = 1;
                    let targetColumnName = `${column.column_name}_${suffix++}`;
                    while(uniqueColumnNameCount[targetColumnName]){
                        targetColumnName = `${column.column_name}_${suffix++}`;
                    }
                    column.column_name = targetColumnName;
                }
                uniqueColumnNameCount[column.column_name] = 1;
                if (column.column_name.length > mxColumnLength) {
                    column.column_name = column.column_name.slice(0, mxColumnLength);
                }
            }
            if (column.title && column.title.length > 255) {
                _catchError.NcError.get(context).invalidRequestBody(`Column title ${column.title} exceeds 255 characters`);
            }
        }
        tableCreatePayLoad.columns = await Promise.all((_tableCreatePayLoad_columns = tableCreatePayLoad.columns) == null ? void 0 : _tableCreatePayLoad_columns.filter((c)=>{
            const allowed = !(0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(c) && !(0, _nocodbsdk.isCreatedOrLastModifiedByCol)(c) || c.system || (0, _nocodbsdk.isOrderCol)(c);
            if (!allowed) {
                virtualColumns.push(c);
            }
            return allowed;
        }).map(async (c)=>{
            // Store original cdf and unique before getColumnPropsFromUIDT potentially overwrites them
            const originalCdf = c.cdf;
            const originalUnique = c.unique;
            const props = await (0, _getColumnPropsFromUIDT.default)(c, source);
            // getColumnPropsFromUIDT already preserves cdf if it was set (see getColumnPropsFromUIDT.ts lines 43-45)
            // But we need to ensure it's preserved here as well in case getColumnPropsFromUIDT didn't preserve it
            // Map unique to ck (column_key) for database operations
            const preservedCdf = originalCdf !== undefined && originalCdf !== null && originalCdf !== '' ? originalCdf : props.cdf !== undefined && props.cdf !== null && props.cdf !== '' ? props.cdf : null;
            return _extends({}, props, {
                cdf: preservedCdf,
                unique: originalUnique !== undefined ? originalUnique : props.unique,
                ck: originalUnique ? 1 : props.ck || 0,
                cn: c.column_name,
                column_name: c.column_name
            });
        }));
        // Validate unique constraints for columns during table creation
        // Do this AFTER getColumnPropsFromUIDT but use preserved cdf value
        for (const column of tableCreatePayLoad.columns){
            if (column.unique) {
                // Use the preserved cdf value from the column object
                const cdfValue = column.cdf;
                (0, _uniqueConstraintHelpers.validateUniqueConstraint)(context, column.uidt, column.meta, !!column.unique, {
                    is_meta: !!source.is_meta,
                    is_local: !!source.is_local
                }, cdfValue);
            }
        }
        await sqlMgr.sqlOpPlus(source, 'tableCreate', _extends({}, tableCreatePayLoad, {
            tn: tableCreatePayLoad.table_name
        }));
        let columns;
        if (!source.isMeta()) {
            var _data, _this, _source_getConfig;
            columns = (_this = await sqlMgr.sqlOpPlus(source, 'columnList', {
                tn: tableCreatePayLoad.table_name,
                schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
            })) == null ? void 0 : (_data = _this.data) == null ? void 0 : _data.list;
        }
        await _models.Model.list(context, {
            base_id: base.id,
            source_id: source.id
        });
        // todo: type correction
        const result = await _models.Model.insert(context, base.id, source.id, _extends({}, tableCreatePayLoad, {
            columns: [
                ...tableCreatePayLoad.columns.map((c, i)=>{
                    const colMetaFromDb = columns == null ? void 0 : columns.find((c1)=>c.cn === c1.cn);
                    return _extends({}, c, {
                        uidt: c.uidt || (0, _getColumnUiType.default)(source, colMetaFromDb || c)
                    }, colMetaFromDb || {}, {
                        title: c.title || (0, _getTableName.getColumnNameAlias)(c.cn, source),
                        column_name: (colMetaFromDb == null ? void 0 : colMetaFromDb.cn) || c.cn || c.column_name,
                        order: i + 1,
                        readonly: c.readonly || false,
                        meta: c.meta || {}
                    });
                }),
                ...virtualColumns.map((c, i)=>_extends({}, c, {
                        uidt: c.uidt || (0, _getColumnUiType.default)(source, c),
                        title: c.title || (0, _getTableName.getColumnNameAlias)(c.cn, source),
                        order: tableCreatePayLoad.columns.length + i + 1
                    }))
            ]
        }));
        try {
            // create nc_order index column
            const metaOrderColumn = tableCreatePayLoad.columns.find((c)=>c.uidt === _nocodbsdk.UITypes.Order);
            if (!metaOrderColumn) {
                throw new Error('Order column not found' + result.id);
            }
            const dbDriver = await _NcConnectionMgrv2.default.get(source);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                model: result,
                source,
                dbDriver
            });
            await sqlClient.raw(`CREATE INDEX ?? ON ?? (??)`, [
                `${tableCreatePayLoad.table_name}_order_idx`,
                baseModel.getTnPath(tableCreatePayLoad.table_name),
                metaOrderColumn.column_name
            ]);
        } catch (e) {
            this.logger.error(`Something went wrong while creating index for nc_order`, e);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_CREATE, {
            table: _extends({}, param.table, {
                id: result.id
            }),
            source,
            user: param.user,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'table_create',
                payload: result
            }
        }, context.socket_id);
        return result;
    }
    constructor(metaDiffService, appHooksService, columnsService){
        this.metaDiffService = metaDiffService;
        this.appHooksService = appHooksService;
        this.columnsService = columnsService;
        this.logger = new _common.Logger(TablesService.name);
    }
};
TablesService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _metadiffsservice.MetaDiffsService === "undefined" ? Object : _metadiffsservice.MetaDiffsService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService
    ])
], TablesService);
